// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_login_login_module_ts":"3652182408821869","src_app_components_my-account_my-account_module_ts":"3bec085bfb5056c1"}[chunkId] + ".js";
};